var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsolationMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 88,
    viewBox: "0 0 48 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9798 8.53958C12.7936 23.0918 9.947 38.8173 13.9962 53.6743C16.8276 63.8837 22.8405 72.2645 30.5279 79.7768C32.72 82.032 30.0103 85.5368 27.2855 83.9825C25.7785 83.0377 24.1344 82.093 22.7187 81.0263C20.892 79.6854 19.0805 78.2073 17.4213 76.6226C16.7515 76.0588 15.1531 74.2912 14.5138 73.6207C13.4177 72.4626 12.4131 71.0455 11.4236 69.796C10.5102 68.4246 9.536 67.0836 8.74442 65.636C8.40953 65.0113 7.70929 63.777 7.37439 63.1523C-1.21113 45.8725 0.920025 24.5699 10.7081 8.37196C11.2257 7.56435 11.6976 6.83293 12.2761 6.04056C14.1789 3.57202 17.9388 5.6139 16.9646 8.55481L16.9798 8.53958Z",
    fill: "#E31837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2152 5.56584L28.4927 11.8896C26.9399 13.4438 26.9399 15.9581 28.4927 17.5124L37.3979 24.0037C37.5653 24.1256 37.7175 24.2628 37.8697 24.3999C41.4014 27.5542 46.9424 23.8361 45.2222 19.2952L44.0501 16.2171C43.6848 15.2419 43.6848 14.1753 44.0501 13.2L45.1309 10.3505C46.8815 5.7487 41.2644 2.00017 37.7023 5.1849C37.5501 5.32204 37.3979 5.45918 37.2304 5.58108L37.2152 5.56584Z",
    fill: "#E31837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2152 31.1362L28.4927 37.4599C26.9399 39.0142 26.9399 41.5284 28.4927 43.0827L37.3979 49.574C37.5653 49.6959 37.7175 49.8331 37.8697 49.9702C41.4014 53.1245 46.9424 49.4217 45.2222 44.8655L44.0501 41.7875C43.6848 40.8122 43.6848 39.7456 44.0501 38.7704L45.1309 35.9209C46.8815 31.319 41.2644 27.5705 37.7023 30.7552C37.5501 30.8923 37.3979 31.0295 37.2304 31.1514L37.2152 31.1362Z",
    fill: "#E31837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationMode);
export default __webpack_public_path__ + "static/media/Isolation_Mode.5da6699abe6b06830fc282f8c8daf4d3.svg";
export { ForwardRef as ReactComponent };